import { TNativeAnalyserNode } from '../types';

export const testAnalyserNodeGetFloatTimeDomainDataMethodSupport = (nativeAnalyserNode: TNativeAnalyserNode): boolean => {
    return typeof nativeAnalyserNode.getFloatTimeDomainData === 'function';
};
